import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  TemplateRef,
  TrackByFunction,
  viewChild
} from '@angular/core';
import {FacetStats, OverviewFilters, QuickView} from "../facets/facet-filter/facet-filter.component";
import {CheckboxSelectionState, openEditModal} from "../../../common/utils";
import {Observable} from "rxjs";
import {FacetUtils} from "../facets/facet-utils";

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewComponent {
  facetUtils = FacetUtils;

  overviewFilters = input.required<OverviewFilters<any>>();
  isEmpty = input<boolean>();
  facetsLoading = input<boolean>();
  facets = input<FacetStats[]>();
  otherFacets = input<FacetStats[]>();
  facetNameFormatter = input<(name: string) => string>();
  searchFunction = input<(term: string) => Observable<any[]> | any[]>();
  quickViews = input<QuickView[]>();
  specificFacetFiltersTemplate = input<TemplateRef<any>>();
  allSelectable = input<boolean>();
  selectionState = input<CheckboxSelectionState>();

  // Virtual scroll inputs
  virtualScroll = input<boolean>(false);
  itemSize = input<number>(65);
  virtualData = input<any[]>([]);
  virtualItemTemplate = input<TemplateRef<any>>();
  virtualTrackBy = input<TrackByFunction<any>>((index) => index);

  readonly facetFiltersChanged = output<OverviewFilters<any>>();
  readonly resultsFound = output<any>();
  readonly loadNextPage = output<void>();
  readonly filtersCleared = output<OverviewFilters<any>>();
  readonly selectionStateChange = output<CheckboxSelectionState>();
  from: number = 0;
  endReached: boolean;
  loading: boolean;

  filtersTemplate = viewChild<TemplateRef<any>>("filtersInModal");

  openFiltersInModal = () => {
    openEditModal(this.filtersTemplate(), null, {
      leftToRight: true,
      size: "auto"
    });
  }

  onFacetValuesChange = (overviewFilters: OverviewFilters<any>) => {
    this.endReached = false;
    this.from = 0;
    this.facetFiltersChanged.emit(overviewFilters);
  }

  changeQuickView = (quickView: QuickView) => {
    this.endReached = false;
    this.from = 0;
    this.facetFiltersChanged.emit({...this.overviewFilters(), selectedQuickView: quickView});
  }

  onVirtualScroll(index: number) {
    if (this.virtualData() && index + 30 >= this.virtualData().length) {
      this.loadNextPage.emit();
    }
  }
}

export interface FacetedOverviewFilters<T> {
  overviewFilters: OverviewFilters<T>;
}
